import * as React from 'react';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { getAllConcepts } from '../../../api/actions/concepts-get-all';
import { AddBreadcrumbsItem } from '../../../components/shared/breadcrumbs/breadcrumbs';
import { basePerformError } from '../../../helpers/error-helpers';
import { IConcept } from '../../../models/concept';
import styles from './concepts-list.module.scss';
import { compareText, repeat } from '../../../helpers/array-helpers';


export function ConceptsList(props: RouteComponentProps) {
    const [concepts, setConcepts] = useState<IConcept[]>([]);

    const loadData = React.useCallback(async () => {
        try {
            setConcepts( buildTree(await getAllConcepts()));
        }
        catch(err) {
            basePerformError(err, props.history);
        }
    }, [props.history]);

    useEffect(() => {
        loadData();
    }, [loadData]);


    const buildTree = (elements: IConcept[]) => {
        if(!elements) return elements;

        const roots = elements.filter(ec => !ec.parent)
            .sort((el1, el2) => compareText(el1, el2, (obj) => obj && obj.name));

        roots.forEach(el => buildTreeNode(el, elements));

        return roots;
    }

    const buildTreeNode = (element: IConcept, elements: IConcept[]) => {
        element.children = elements.filter(ec => ec.parent && ec.parent.includes(element.uid))
            .sort((el1, el2) => compareText(el1, el2, (obj) => obj && obj.name));

            element.children.forEach(el => buildTreeNode(el, elements));


    }

    const printLevel = (elements?: IConcept[], level = 0) => elements
        && elements.map((el => (
            <React.Fragment key={el.uid}>
                <tr key={el.uid}>
                    <td>
                        {!!level && repeat(level, () => (
                            <span>
                                &raquo;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        ))}
                        {el.name}
                    </td>
                    <td>
                        {el.description}
                    </td>
                </tr>
                {printLevel(el.children, level + 1)}
            </React.Fragment>
        )));


    return !concepts ? null : (
        <>
            <AddBreadcrumbsItem
                title="Concepts"
                url={'/libraries/concepts'}
            />

            <table cellPadding="0" cellSpacing="0" className={`list`}>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    { printLevel(concepts) }
                </tbody>
            </table>
        </>
    );
}
